import React, { useEffect, useRef, useState } from "react";
import "./Testimonial.css";

const testimonials = [
  {
    name: " मकरंद बुरांडे",
    time: "६ वर्षांपूर्वी",
    text:
      "पुस्तकांचा खजिना म्हणजे हे ग्रंथालय आहे. जुने, व्यवस्थित आणि उत्तमरीत्या सांभाळलेले ग्रंथालय. काही कारणांमुळे मी इथून सदस्यत्व सोडलं, पण आजही या ग्रंथालयाच्या आठवणी मनात आहेत. संगणकावर पुस्तक शोधण्याची सुविधा उत्कृष्ट आहे.",
  },
  {
    name: "सुनिता पवार",
    time: "४ वर्षांपूर्वी",
    text:
      "अतिशय शांत आणि अभ्यासासाठी योग्य वातावरण आहे. प्रत्येक प्रकारची पुस्तके सहज उपलब्ध आहेत. ग्रंथालयाची सेवा खूपच प्रशंसनीय आहे.",
  },
];

const Testimonials = () => {
  const sectionRef = useRef(null);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate");
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const prev = () => {
    setIndex((index - 1 + testimonials.length) % testimonials.length);
  };

  const next = () => {
    setIndex((index + 1) % testimonials.length);
  };

  return (
    <section className="testimonials-section" ref={sectionRef}>
      <h2>“सभासदांच्या प्रतिक्रिया”</h2>

      <div className="testimonial-card">
        <button className="nav-btn left" onClick={prev}>
          ‹
        </button>

        <div className="testimonial-content">
          <h3>{testimonials[index].name}</h3>
          <span>{testimonials[index].time}</span>
          <p>{testimonials[index].text}</p>

          <div className="stars">★★★★★</div>
        </div>

        <button className="nav-btn right" onClick={next}>
          ›
        </button>
      </div>
    </section>
  );
};

export default Testimonials;
